import { createStoreChunk } from '@core/store'

export type TDownloadAudio = {
    id: string
    title: string
    authorUsername: string
    authorId: string
    avatarUrl: string
}

type TDownloadDialogState = {
    audio: TDownloadAudio | null
}

export const downloadDialogStore = createStoreChunk<TDownloadDialogState>('download')({
    initialState: { audio: null },
})
